import * as ko from 'knockout';
import {IKnockoutComponent, IRouteDefinitionParams, TRouteId} from '../../index';
import {nsRoute} from '../../util/route';
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import tabPanelsHtml from './tab-panels.html?raw';

export const template = tabPanelsHtml;

interface ITabPanel {
    __routeId: TRouteId
    component: IKnockoutComponent
}

/**
 * Content-wrapper for PageShell: one panel per tab via route-destination.
 * Soft-nav only flips currentId; chrome and panels both follow isCurrent().
 */
export class viewModel extends ParsedRouteDataDecorator {
    readonly panels: KnockoutComputed<ITabPanel[]>;

    constructor(params: IRouteDefinitionParams) {
        super(params);
        // Stable once: getDestinations reads no observables (getAllTabs is plain).
        this.panels = ko.pureComputed(() => this.__tabManager?.getDestinations() ?? []);
    }
}
